// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core_Ui_ConfigButton$SensumPwa from "../configButton/Core_Ui_ConfigButton.bs.js";
import * as Core_Ui_GraveyardButton$SensumPwa from "../graveyardButton/Core_Ui_GraveyardButton.bs.js";
import * as Core_Ui_SanctuaryButton$SensumPwa from "../sanctuaryButton/Core_Ui_SanctuaryButton.bs.js";

function Core_Ui_Navbar$DefaultRightComponent(Props) {
  return React.createElement("div", {
              className: "flex"
            }, React.createElement(Core_Ui_GraveyardButton$SensumPwa.make, {}), React.createElement(Core_Ui_SanctuaryButton$SensumPwa.make, {}), React.createElement(Core_Ui_ConfigButton$SensumPwa.make, {}));
}

var DefaultRightComponent = {
  make: Core_Ui_Navbar$DefaultRightComponent
};

function Core_Ui_Navbar(Props) {
  var rightComponentOpt = Props.rightComponent;
  var rightComponent = rightComponentOpt !== undefined ? Caml_option.valFromOption(rightComponentOpt) : React.createElement(Core_Ui_Navbar$DefaultRightComponent, {});
  var onClick = function ($$event) {
    $$event.preventDefault();
    window.location.reload(true);
  };
  return React.createElement("header", {
              className: "border-purple-900 border-b-2 flex justify-between"
            }, React.createElement("div", {
                  className: "flex flex-row items-baseline group relative"
                }, React.createElement("h1", {
                      className: "pl-2 text-xl lg:text-4xl text-purple-50"
                    }, "δensum"), React.createElement("button", {
                      onClick: onClick
                    }, React.createElement("a", {
                          className: "pl-2 text-sm lg:text-md text-purple-50"
                        }, "(v" + import.meta.env.APP_VERSION + ")"))), rightComponent);
}

var make = Core_Ui_Navbar;

export {
  DefaultRightComponent ,
  make ,
}
/* react Not a pure module */
